import { useService } from "./service.js";
import debounce from "../utils/debounce.js";
let breakpointElement;
let breakpoints = [];
function getBreakpointElement() {
  if (!breakpointElement) {
    breakpointElement = document.querySelector("[data-breakpoint]");
  }
  return breakpointElement;
}
function getBreakpoint() {
  return getBreakpointElement() ? window.getComputedStyle(getBreakpointElement(), "::before").getPropertyValue("content").replaceAll('"', "") : void 0;
}
function getBreakpoints() {
  if (!getBreakpointElement() || breakpoints.length) {
    return breakpoints;
  }
  breakpoints = window.getComputedStyle(getBreakpointElement(), "::after").getPropertyValue("content").replaceAll('"', "").split(",");
  return breakpoints;
}
function createResizeService() {
  function updateProps() {
    props.width = window.innerWidth;
    props.height = window.innerHeight;
    props.ratio = window.innerWidth / window.innerHeight;
    props.orientation = "square";
    if (props.ratio > 1) {
      props.orientation = "landscape";
    }
    if (props.ratio < 1) {
      props.orientation = "portrait";
    }
    return props;
  }
  const onResize = debounce(() => {
    trigger(updateProps());
  });
  const { add, remove, has, trigger, props } = useService({
    props: {
      width: window.innerWidth,
      height: window.innerHeight,
      ratio: window.innerWidth / window.innerHeight,
      orientation: "square",
      get breakpoint() {
        return getBreakpoint();
      },
      get breakpoints() {
        return getBreakpoints();
      }
    },
    init() {
      window.addEventListener("resize", onResize);
    },
    kill() {
      window.removeEventListener("resize", onResize);
    }
  });
  return {
    add,
    remove,
    has,
    props: () => props
  };
}
let resize;
function useResize() {
  if (!resize) {
    resize = createResizeService();
  }
  return resize;
}
export {
  useResize as default
};
